export async function getGeographyAggregatesByTerritory(marketId, territoryId) {
    if (!marketId || !territoryId) {
        throw new Error('Missing required parameters');
    }

    const url = `${process.env.REACT_APP_API_URL}GeographyAggregateByTerritory/${encodeURIComponent(marketId)}/${encodeURIComponent(territoryId)}`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}
export async function getGeographyAggregates(filter, favoriteOnly) {
    const url = `${process.env.REACT_APP_API_URL}GeographyAggregate?favoriteOnly=${favoriteOnly}&filter=${encodeURIComponent(filter)}`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
    });
    if (response.status === 200) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

export async function getGeographyAggregateById(id, marketId, territoryId) {
    if (!marketId || !territoryId) {
        throw new Error('Missing required parameters');
    }
    const url = `${process.env.REACT_APP_API_URL}GeographyAggregate/${encodeURIComponent(id)}?marketId=${encodeURIComponent(marketId)}&territoryId=${encodeURIComponent(territoryId)}`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (response.status === 200) {
        const data =  await response.json();
        return {...data.prescriber, favorite: data.favorite};
    } else {
        throw response.statusText;
    }
}
